import { Component, OnInit } from '@angular/core';
import { RazlogPrestankaRo } from './razlog-prestanka-ro';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-razlog-prestanka-ro-modal-update',
  templateUrl: './razlog-prestanka-ro-modal-update.component.html'
})
export class RazlogPrestankaRoModalUpdateComponent
extends BaseModalUpdateComponent<RazlogPrestankaRo>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RazlogPrestankaRo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
